import CardBody from "./CardBody";

export default CardBody;